import { gql } from '@apollo/client';

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences(
    $input: UpdateNotificationPreferencesInput!
  ) {
    updateNotificationPreferences(input: $input)
  }
`;

export interface UpdateNotificationPreferencesInput {
  pushNotifications?: boolean;
  exchangeUpdates?: boolean;
  newFollowers?: boolean;
  assetSaved?: boolean;
  chatMessages?: boolean;
}

export interface NotificationPreferences {
  pushNotifications: boolean;
  exchangeUpdates: boolean;
  newFollowers: boolean;
  assetSaved: boolean;
  chatMessages: boolean;
}
